import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ValidatorFn, Validators } from '@angular/forms';
import { take } from 'rxjs/operators';
import { apiLinks } from 'src/app/core/api-links/api-links';
import { CommonService } from 'src/app/providers/common.service';
import { WizardComponent } from 'angular-archwizard';
import { MessageService } from 'primeng/api';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { MerchantBillingDialogComponent } from 'src/app/shared/components/merchant-billing-dialog/merchant-billing-dialog.component';
import { EditTpnOpenBatchModalComponent } from 'src/app/shared/components/edit-tpn-open-batch-modal/edit-tpn-open-batch-modal.component';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginAsModalComponent } from 'src/app/shared/components/login-as-modal/login-as-modal.component';
import { AuthService } from 'src/app/providers/auth.service';
import { UserService } from 'src/app/providers/user.service';
import { Users } from 'src/app/core/model/user';
import { forkJoin } from 'rxjs';
import { Modules } from 'src/app/core/model/modules.enum';
import { Privileges } from 'src/app/core/model/privileges.enum';
@Component({
  selector: 'app-merchant-billing-settings',
  templateUrl: './merchant-billing-settings.component.html',
  styleUrls: ['./merchant-billing-settings.component.scss']
})

export class MerchantBillingSettingsComponent implements OnInit, AfterViewInit {
  @ViewChild('wizard', { static: false }) wizard: WizardComponent;
    modules = Modules;
    privileges = Privileges;
  public customerInfo: any = localStorage.getItem('current_user') ? JSON.parse(localStorage.getItem('current_user')) : {};
  public merchantInfo: any = {};
  public storeInfo: any = {};
  public tpnInfo: any = {};
  public prefLoader: boolean = true;
  public submitLoader: boolean = false;
  public isShowPreference: boolean;
  public conractForm: any = {};
  public conractFormLoader: string = 'true';
  public customRegex = /^[A-Za-z0-9 _$'.!%,-@&]{0,150}$/;
  public billingPreferenceForm: FormGroup = new FormGroup({
    paymentLinkDescription: new FormControl('', [Validators.pattern(this.customRegex),
    Validators.maxLength(150)]), disclaimer: new FormControl('', [Validators.pattern(this.customRegex),
    Validators.maxLength(150)]),
  });
  public queryParams: any = this.activeRoute.snapshot.queryParams;
  public from: string = this.queryParams.from;
  public isDisableProxyLogin: boolean = false;  
  public editBilling: boolean = this.isAccess(Modules.MERCHANT_BILLING, Privileges.EDIT_BILLING);
  public billingSummary :any;
  public billingStatus :any;
  constructor(
    private common: CommonService,
    private messageService: MessageService,
    private ngbModal: NgbModal,
    private route: Router,
    private activeRoute: ActivatedRoute,
    private userService: UserService,
    private authService: AuthService,

  ) { 
    this.billingSummary = this.queryParams.billingSummary ? JSON.parse(this.queryParams.billingSummary) : {};
    this.billingStatus = this.queryParams.billingStatus ? JSON.parse(this.queryParams.billingStatus) : {};
  }

  ngOnInit(): void {
    this.getAccountInfo();
    this.contractFormFn({ invalid: true, value: {} });
    this.getProxyLoginDetails();
    if(!this.editBilling){
     this.billingPreferenceForm.disable();
    }
  }

  ngAfterViewInit(): void {
    const goTo = this.queryParams.to == 's-s-p' ? 1 : 0;
    this.goToStep(goTo);
    setTimeout(() => {
      this.isShowPreference = !['bulk_update', 'bulk_enable'].includes(this.from);
    }, 50);
  }


  getAccountInfo = () => {
    this.common.getCommonHttpClientParams(apiLinks.merchantBilling.accountInfo).pipe(take(1)).subscribe((res: any) => {
      this.prefLoader = false;
      if (!res.data) {
        console.log('show erorr toaster');
        return;
      }
      this.merchantInfo = {
        dba: res.data.merchantDba,
        merchantId: res.data.merchantId,
        merchantEmail: res.data.email,
        userId: res.data.userId
      }
      const storeData = res.data.merchant_to_stores?.length ? res.data.merchant_to_stores[0] : {};
      this.storeInfo = {
        dba: storeData?.storeDba || null,
        storeId: storeData?.storeId || null,
        storeEmail: storeData?.email || null
      }
      const tpnData = storeData?.store_to_tpns?.length ? storeData?.store_to_tpns[0] : {};
      this.tpnInfo = {
        tpn: tpnData.tpn || null,
        tpnId: tpnData.tpnId || null,
        defaultLabel: tpnData.defaultLabel || null,

      }
      this.billingPreferenceForm.setValue({
        paymentLinkDescription: res.data?.billingPreference?.paymentLinkDescription || 'Gateway Fee',
        disclaimer: res.data?.billingPreference?.disclaimer || '',
      })
    }, (error) => {
      this.prefLoader = false;
      this.showToaster('error', '', error.message || 'Serv');
    })
  }


  saveOrUpdateSellingPrice = async (reqObj, navigate = true) => {
    try {
      const res = await this.common.postCommonHttpClient(apiLinks.merchantBilling.saveSellingPrice, reqObj).toPromise();
      this.showToaster('success', '', res.message);
      if (navigate) {
        this.ngbModal.dismissAll();
        this.route.navigate(['/billing-invoice/m-b'])
      }
    } catch (error) {
      this.showToaster('error', '', error.message);
    }

  }

  submitForm = () => {
    if (this.from == 'bulk_update') {
      const jobId = this.generateJobId();
      let bulkUpdateModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
      bulkUpdateModalRef.componentInstance.action = 'bulk_update';
      bulkUpdateModalRef.componentInstance.loader = true;
      bulkUpdateModalRef.componentInstance.metaData = { jobId, totalMerchants: this.queryParams.totalMerchants };
      bulkUpdateModalRef.componentInstance.event.subscribe((res: any) => {
        if (res.action == 'submit') {
          const bulkReqObj = {
            customerId: this.customerInfo.customerId,
            template: {
              ...this.conractForm.changedValue
            },
            action: 'bulk_update',
            jobId
          }
          if (res.checked) {
            const sellPriceObj = {
              customerId: this.customerInfo.customerId,
              billingPreference: this.billingPreferenceForm.value,
              template: {
                ...this.conractForm.value
              },
              updateSellingPrice: res.checked
            }
            this.saveOrUpdateSellingPrice(sellPriceObj, false);
            this.bulkEnable(bulkReqObj);
          } else {
            this.bulkEnable(bulkReqObj);
          }
        }
      });

    } else if (this.from == 'pref_sell_price') {
      let updateSellPriceConfirmModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
      updateSellPriceConfirmModalRef.componentInstance.action = 'update_sell_price_confirm';
      updateSellPriceConfirmModalRef.componentInstance.loader = true;
      updateSellPriceConfirmModalRef.componentInstance.event.subscribe((res: any) => {
        if (res.action == 'submit') {
          const sellPriceObj = {
            customerId: this.customerInfo.customerId,
            billingPreference: this.billingPreferenceForm.value,
            template: {
              ...this.conractForm.value
            }
          }
          this.saveOrUpdateSellingPrice(sellPriceObj);
        }
      });
    } else if (this.from == 'bulk_enable') {
      this.bulkEnableConfirmDialog();
    }
    else if (this.from == 'collection_account' || !this.queryParams.setSellingPrice) {
      let saveConfirmModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
      saveConfirmModalRef.componentInstance.action = 'save_price_confirm';
      saveConfirmModalRef.componentInstance.loader = true;
      saveConfirmModalRef.componentInstance.event.subscribe((res: any) => {
        if (res.action == 'submit') {
          saveSellingPriceAndBulkEnable();
        }
      });
    }

    const saveSellingPriceAndBulkEnable = () => {
      // this.submitLoader = true;
      const reqObj = {
        customerId: this.customerInfo.customerId,
        billingPreference: this.billingPreferenceForm.value,
        template: {
          ...this.conractForm.value
        }
      }

      this.common.postCommonHttpClient(apiLinks.merchantBilling.saveSellingPrice, reqObj).pipe(take(1)).subscribe((res: any) => {
        this.submitLoader = false;
        this.ngbModal.dismissAll();
        this.showToaster('success', '', res.message);
        if (!this.billingSummary.totalMerchants) {
          this.route.navigate(['/billing-invoice/m-b']);
          return;
        } 
        this.bulkEnableDialog(reqObj);
      }, (error) => {
        this.submitLoader = false;
        this.ngbModal.dismissAll();
        this.showToaster('error', '', error.message);
      })
    }
  }

  generateJobId = () => {
    return `${crypto.randomUUID()}_${new Date().toISOString()}`;
  }

  bulkEnableConfirmDialog = () => {
    const jobId = this.generateJobId();
    const reqObj = {
      customerId: this.customerInfo.customerId,
      template: {
        ...this.conractForm.value
      },
      jobId,
      action: 'bulk_enable'
    }
    let bulkEnableConfirmModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
    bulkEnableConfirmModalRef.componentInstance.action = 'bulk_enable_confirm';
    bulkEnableConfirmModalRef.componentInstance.loader = true;
    bulkEnableConfirmModalRef.componentInstance.metaData = { jobId, pendingMerchants: this.queryParams.pendingMerchants };
    bulkEnableConfirmModalRef.componentInstance.event.subscribe((res: any) => {
      if (res.action == 'submit') {
        this.bulkEnable(reqObj);
      }
    });
    bulkEnableConfirmModalRef.result.then((result) => {
      if (result == 'bulk_enable_confirm_submit') {
        reqObj.action = 'bulk_enable';
        this.bulkEnable(reqObj);
      } else {
        this.route.navigate(['/billing-invoice/m-b'])
      }
    })
  }
  bulkEnableDialog = (reqObj: any) => {
    let bulkEnableModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
    bulkEnableModalRef.componentInstance.action = 'bulk_enable';

    bulkEnableModalRef.result.then((result) => {
      if (result == "bulk_enable_submit") {

        this.bulkEnableConfirmDialog();
      } else {
        this.route.navigate(['/billing-invoice/m-b'])
        return;
      }
    })
  }

  bulkEnable = (template: any) => {
    // this.submitLoader = true;
    this.common.postCommonHttpClient(apiLinks.merchantBilling.bulkEnable, template).pipe(take(1)).subscribe((res: any) => {
      setTimeout(() => {
        this.submitLoader = false;
        this.ngbModal.dismissAll();
        this.showToaster('success', '', res.message);
        this.route.navigate(['/billing-invoice/m-b'])
      }, 1000 * 3);

    }, error => {
      this.submitLoader = false;
      this.ngbModal.dismissAll();
      if (error?.responseMessage == 'ASK_BULK_ENABLE') {
        let bulkUpdateFailedAskBulkEnableModalRef = this.ngbModal.open(MerchantBillingDialogComponent, { backdrop: 'static', keyboard: false, size: 'md', centered: true });
        bulkUpdateFailedAskBulkEnableModalRef.componentInstance.action = 'bulk_update_failed_ask_bulk_enable';
        bulkUpdateFailedAskBulkEnableModalRef.result.then((result) => {
          if (result == 'bulk_update_failed_ask_bulk_enable_submit') {
            this.bulkEnableConfirmDialog();
          } else {
            this.route.navigate(['/billing-invoice/m-b'])
          }
        })
        return;
      }
      this.showToaster('error', '', error.message);
    })
  }

  showToaster(type, define, message) {
    this.messageService.add({
      severity: type,
      summary: define,
      detail: message,
      key: 'copy-toast'
    });
  }

  goToStep = (step = 0) => {
    if (this.isShowPreference == false) {
      this.route.navigate(['/billing-invoice/m-b'])
      return;
    }
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
    setTimeout(() => {
      this.wizard?.goToStep(step);
    }, 100);
  }

  contractFormFn = (contract: any) => {
    this.conractForm = contract;
  }
  contractFormLoaderFn = (loader: string) => {
    this.conractFormLoader = loader;
  }

  navigateFn = (to: string) => {
    const common = { from: this.from, route: 'm-b-s', backtopage: 'm-b-s' }
    switch (to) {
      case 'EDIT_MERCHANT':
        this.route.navigate(['/merchant-management/merchant-create-management/edit-merchant'], { queryParams: { id: this.merchantInfo.merchantId, type: 'edit-merchant', gostep: '0', ...common } })
        break;
      case 'EDIT_STORE':
        this.route.navigate(['/merchant-management/merchant-create-management/edit-store'], { queryParams: { id: this.storeInfo.storeId, type: 'edit_store', btn: "1", gostep: '1', ...common } });
        break;
      case 'ADD_ON_FEATURE':
        this.route.navigate(['/merchant-management/add-on-features'], { queryParams: { id: this.storeInfo.storeId, mid: this.merchantInfo.merchantId, ...common, type: 'edit_AddOn' } });
        break;
      case 'ABOUT_DEVICE':
        this.route.navigate(['/steam-param/tpn-snapshot'], { queryParams: { tpn: this.tpnInfo?.tpn, ...common } });
        break;
      case 'EDIT_PARAMS':
        this.route.navigate(['/params-management/add-params'], { queryParams: { id: this.tpnInfo?.tpnId, ...common } });
        break;
      case 'EDIT_TPN':
        this.routeToEditTPns();
        break;

      default:
        break;
    }

  }

  routeToEditTPns() {
    const tpnId = this.tpnInfo.tpnId;
    const tpn = this.tpnInfo.tpn;
    let tpnData = { tpnId, paramEdit: true }
    this.common.getCommonHttpClientQueryParams(apiLinks.isoCheckOpenBatch, tpnData).subscribe(data => {
      if (data.message.status == true) {
        this.route.navigate(['/merchant-management/merchant-create-management/edit-tpns'], { queryParams: { id: tpnId, tpn: tpn, gostep: '2', from: this.from, route: 'm-b-s', backtopage: 'm-b-s' } });
      } else {
        let modalRef = this.ngbModal.open(EditTpnOpenBatchModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
        modalRef.componentInstance.tpn = tpn;
        modalRef.componentInstance.route = 'tpn';
        modalRef.result.then((result) => {
          if (result == 'goToBatches') {
            this.ngbModal.dismissAll();
          }
        });
      }
    });

  }

  loginAs() {
    if (!this.merchantInfo?.userId) {
      return;
    }
    let modalRef = this.ngbModal.open(LoginAsModalComponent, { ariaLabelledBy: 'modal-basic-title', centered: true, backdrop: 'static', keyboard: false });
    modalRef.componentInstance.isLoading = true
    modalRef.componentInstance.header = `LOGIN-AS CONFIRMATION`;
    let payLoad = {
      ownedByCustomer: this.customerInfo.customerId
    };
    let getUserApi = this.userService.getUser(this.userService.getUserById, { id: this.merchantInfo?.userId });
    let getProxyEmailStatusApi = this.common.getCommonHttpClientQueryParams(apiLinks.isEnableProxyEmailAlert, payLoad);
    forkJoin([getUserApi, getProxyEmailStatusApi]).pipe(take(1)).subscribe(([userApiRes, proxyEmailRes]) => {
      const userResponse = userApiRes as Users
      modalRef.componentInstance.body = `Do you want to login as your Collection Account ?`;
      modalRef.componentInstance.confirmButton = `Confirm`
      modalRef.componentInstance.email = userResponse.email;
      // modalRef.componentInstance.password = userResponse.secondaryPassword;
      modalRef.componentInstance.systemUser = this.authService.getUser.firstName + " " + this.authService.getUser.lastName;
      modalRef.componentInstance.systemEmail = this.authService.getUser.email;
      modalRef.componentInstance.isLoading = false;
      modalRef.componentInstance.loginUser = 'Merchant';
      modalRef.componentInstance.isEnableProxyEmail = proxyEmailRes.isEnableProxyMail;
    }, (err) => {
      modalRef.componentInstance.isLoading = false
      modalRef.componentInstance.body = `Error occurred, ${err.message}`;
      modalRef.componentInstance.isError = true

    });

  }

   getProxyLoginDetails() {
    this.common.getCommonHttpClientParams(apiLinks.getProxyAlertDetails + '/' + this.customerInfo.customerId).subscribe((res) => {
      if (res.data?.length) {
        this.isDisableProxyLogin = res.data.find((d: any) => { return d.isoPreferences_to_isoPreferenceMapping?.code == "isMerchantLoginAs" })?.status == 'ACTIVE' ? false : true;
      } else {
        this.isDisableProxyLogin = true;
      }
    }, (err) => {
      this.isDisableProxyLogin = true;

    })
  }

  isAccess(module, privileges) {
    return this.authService.isFeatureEnabled(module, privileges);
  }

}